import { CONFIG } from '../config.js';

const HALF_DEPTH = CONFIG.player.width / 2;
const HALF_WIDTH = CONFIG.player.hitWidth / 2;
const COIN_REACH_S = 0.8;
const COIN_REACH_X = 0.75;
const COIN_REACH_Y = 0.35;
const POWERUP_REACH_S = 1.0;
const POWERUP_REACH_X = 0.9;
const PIT_MARGIN_S = 0.2;
const PIT_MARGIN_X = 0.1;

/** Primer obstáculo activo del tramo actual que se solapa con el jugador (a lo largo, a lo ancho y en altura). */
export function findHit(player) {
  const { s, x } = player;
  const bottom = player.y;
  const top = player.y + player.height;
  for (const o of player.segment.obstacles) {
    if (o.hit || o.broken) continue;
    if (Math.abs(s - o.s) > o.depth / 2 + HALF_DEPTH) continue;
    if (x + HALF_WIDTH <= o.xMin || x - HALF_WIDTH >= o.xMax) continue;
    if (top > o.bottom && bottom < o.top) return o;
  }
  return null;
}

/**
 * Foso bajo el jugador, si lo hay. Cuenta el centro del cuerpo con un pequeño margen: rozar
 * el borde no hace caer, pero meterse en el hueco (o aterrizar dentro) sí.
 */
export function pitUnder(player) {
  const { s, x } = player;
  for (const pit of player.segment.pits) {
    if (s > pit.s0 + PIT_MARGIN_S && s < pit.s1 - PIT_MARGIN_S && x > pit.xMin + PIT_MARGIN_X && x < pit.xMax - PIT_MARGIN_X) {
      return pit;
    }
  }
  return null;
}

/** ¿Está el objeto (moneda o potenciador) al alcance del jugador? */
function inReach(player, item, reachS, reachX) {
  if (Math.abs(player.s - item.s) > reachS || Math.abs(player.x - item.x) > reachX) return false;
  return item.y >= player.y - COIN_REACH_Y && item.y <= player.y + player.height + COIN_REACH_Y;
}

/** Recoge las monedas (y gemas) al alcance del jugador. Devuelve cuántas monedas valen en total. */
export function collectCoins(player, path) {
  let n = 0;
  for (const c of player.segment.coins) {
    if (c.taken || c.flying || !inReach(player, c, COIN_REACH_S, COIN_REACH_X)) continue;
    path.takeCoin(c);
    n += c.value;
  }
  return n;
}

/** Recoge el potenciador al alcance del jugador, si lo hay. Devuelve su tipo o null. */
export function collectPowerUp(player, path) {
  for (const p of player.segment.powerUps) {
    if (p.taken || !inReach(player, p, POWERUP_REACH_S, POWERUP_REACH_X)) continue;
    path.takePowerUp(p);
    return p.type;
  }
  return null;
}
